// @ts-nocheck
import { createService } from "@/integration/factory/service-factory.ts";
import {
  ICreateTeamRecruitmentRequest,
  ITeamRecruitment,
  IUpdateTeamRecruitmentRequest,
} from "../interfaces/team-recruitment.interface";

/**
 * Service for team recruitment-related API calls
 */
export default function teamRecruitmentService() {
  // Create base services for team recruitment endpoints
  const teamsService = createService("/teams");

  /**
   * Get team recruitment
   * @param teamId The team ID
   * @returns The team recruitment
   */
  const getTeamRecruitment = async (
    teamId: string
  ): Promise<ITeamRecruitment | null> => {
    try {
      return await teamsService.customGet<ITeamRecruitment>(
        `/${teamId}/recruitment`
      );
    } catch (error) {
      console.error("Error fetching team recruitment:", error);
      return null;
    }
  };

  /**
   * Create team recruitment
   * @param teamId The team ID
   * @param data The recruitment data
   * @returns The created team recruitment
   */
  const createTeamRecruitment = async (
    teamId: string,
    data: ICreateTeamRecruitmentRequest
  ): Promise<ITeamRecruitment | null> => {
    try {
      return await teamsService.customPost<ITeamRecruitment>(
        `/${teamId}/recruitment`,
        { ...data, team_id: teamId }
      );
    } catch (error) {
      console.error("Error creating team recruitment:", error);
      return null;
    }
  };

  /**
   * Update team recruitment
   * @param teamId The team ID
   * @param data The recruitment data
   * @returns The updated team recruitment
   */
  const updateTeamRecruitment = async (
    teamId: string,
    data: IUpdateTeamRecruitmentRequest
  ): Promise<ITeamRecruitment | null> => {
    try {
      return await teamsService.customPut<ITeamRecruitment>(
        `/${teamId}/recruitment`,
        data
      );
    } catch (error) {
      console.error("Error updating team recruitment:", error);
      return null;
    }
  };

  /**
   * Toggle team recruitment status
   * @param teamId The team ID
   * @param isActive Whether recruitment is active
   * @returns The updated team recruitment
   */
  const toggleRecruitmentStatus = async (
    teamId: string,
    isActive: boolean
  ): Promise<ITeamRecruitment | null> => {
    try {
      const status = isActive ? 'active' : 'inactive';
      return await teamsService.customPut<ITeamRecruitment>(
        `/${teamId}/recruitment/toggle/${status}`
      );
    } catch (error) {
      console.error("Error toggling team recruitment status:", error);
      return null;
    }
  };

  return {
    getTeamRecruitment,
    createTeamRecruitment,
    updateTeamRecruitment,
    toggleRecruitmentStatus,
  };
}